<!-- eslint-disable -->
<template lang="pug">
    div
        .title
            slot(name='title')
        form(action='javascript://', v-if='params')
            .form-container
                .row(v-if="gameMode !== 'course'")
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_gameWithTime') }}
                        .form-container__select
                            cs-multiselect(
                                :multiple='false',
                                :options='gameTypes',
                                :show-labels='false',
                                :allow-empty='false',
                                track-by='name',
                                label='name',
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                                v-model='selectedGameType',
                                @select='gameTypeHandler'
                            )
                slot(name='multiplayer')
                .row(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
                        .form-container__select
                            cs-multiselect(
                                :multiple='false',
                                :options='modes',
                                :show-labels='false',
                                :allow-empty='false',
                                track-by='name',
                                label='name',
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseMode')",
                                v-model='selectedMode',
                                @select='params.mode = $event.value'
                            )
                .row
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
                        .form-container__select
                            cs-multiselect(
                                :multiple='false',
                                :options='difficult',
                                :show-labels='false',
                                :allow-empty='false',
                                track-by='name',
                                label='name',
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseDifficulty')",
                                v-model='selectedDifficult',
                                @select='difficultHandler'
                            )
                .row(v-if="gameMode !== 'course'")
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_combiningNumOfDigits') }}
                        .form-container__select.form-container__select_spaced
                            cs-checkbox(
                                :checked='params && params.combining',
                                @change='combiningHandler',
                                :disabled='combiningDisabled'
                            )
                combining-digit-capacity(
                    v-if='params.combining && !params.roundNumbers && !params.fractions',
                    :filtered-combining-digit-capacities='filteredCombiningDigitCapacities',
                    :combining-digit-capacities='params.combiningDigitCapacities',
                    :combining-digit-capacity-labels='combiningDigitCapacityLabels',
                    @changeCombiningDigitCapacities='changeCombiningDigitCapacities'
                )
                .row(v-if="gameMode !== 'course'")
                    .form-container__column.form-container__column_fixed
                        label.form-container__label.form-container__label_fixed.input-label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfActions') }}
                        .form-container__select.form-container__select_short
                            cs-spin-input(
                                :value="params.amountOfActions",
                                :max="actions",
                                :min="2",
                                @increase="increaseActions",
                                @decrease="decreaseActions",
                                @input="params.amountOfActions = $event",
                            )
                .row(v-if="gameMode !== 'course'")
                    .form-container__column.form-container__column_fixed
                        label.form-container__label.form-container__label_fixed.input-label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                        .form-container__select.form-container__select_short.form-container__select-examples
                            cs-spin-input(
                                :value="params.amountOfExamples",
                                :max="examples",
                                :min="1",
                                :disabled="params && (params.infinityAmountOfExamples || !!params.timeLimit)",
                                @increase="increaseExamples",
                                @decrease="decreaseExamples",
                                @input="params.amountOfExamples = $event"
                            )
                            .form-container__select-infinity-mode(v-if="gameMode && gameMode === 'free-game'")
                                cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                                    v-model="params.infinityAmountOfExamples"
                                    :checked="params && params.infinityAmountOfExamples"
                                    :disabled="params && (!!params.timeLimit || !!params.dictation)"
                                )
                                svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
                .row(v-show="isTimeLimitAvailable")
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
                        .form-container__select
                            cs-multiselect(
                                v-model="selectedTimeLimit",
                                @select="timeLimitHandler"
                                :disabled="params.dictation",
                                :options="formattedTimeLimitValues",
                                :show-labels="false",
                                :allow-empty="false",
                                label="label",
                                track-by="amount",
                                :multiple="false",
                                :hide-selected="false",
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_noSpecified')",
                                :searchable="false",
                            )
                .row(v-if='levelAnswerDuration && params && !params.withTime')
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
                        .form-container__select
                            cs-multiselect(
                                v-model='selectedAnswerDuration',
                                @select="answerDurationHandler",
                                label="label",
                                track-by="time",
                                :options="secondsInMinute",
                                :multiple="false",
                                :hide-selected="false",
                                :show-labels="false",
                                :allow-empty="false",
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_noSpecified')",
                                :searchable="false",
                            )
                            help-text.add-sub-form__help-text(
                                v-if='showAnswerDurationHelpText',
                                slot='help-text',
                                v-text="$i18n.t('trainer.trainer_gameFormHelpText_emptyField')"
                            )
                .row(v-if="gameMode !== 'course'")
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_displaySpeed') }}
                        .form-container__select
                            cs-multiselect(
                                v-model='selectedSpeed',
                                @select="displaySpeedHandler",
                                label="label",
                                track-by="time",
                                :options="formattedSeconds",
                                :multiple="false",
                                :hide-selected="false",
                                :show-labels="false",
                                :allow-empty="false",
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_noSpecified')",
                                :searchable="false",
                            )
                            help-text.add-sub-form__help-text(
                                v-if='params.withTime && showDisplaySpeedHelpText',
                                slot='help-text',
                                v-text="$i18n.t('trainer.trainer_gameFormHelpText_tooHighSpeed')"
                            )
                template(v-if="gameMode !== 'course' && params.withTime")
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_speedIncreasing') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#isSpeedIncrease(
                                    v-model='params.isSpeedIncrease',
                                    :checked='params && params.isSpeedIncrease',
                                    :disabled="isSpeedIncreaseDisabled"
                                )
                    template(v-if='params.isSpeedIncrease')
                        .row
                            .form-container__column
                                label.form-container__label
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_exampleSpeedIncreasing') }}
                                .form-container__select
                                    cs-multiselect(
                                        v-model='params.tasksForSpeedUp',
                                        :options="tasksForSpeedUpOptions"
                                        :multiple="false",
                                        :show-labels="false",
                                        :allow-empty="false",
                                        placeholder=""
                                        :searchable="false",
                                    )
                        .row
                            .form-container__column
                                label.form-container__label
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_speedIncreasingOn') }}
                                .form-container__select
                                    cs-multiselect(
                                        v-model='selectedSpeedUp',
                                        @select="speedUpHandler",
                                        :options="secondsForSpeedUp",
                                        track-by="time",
                                        label="label",
                                        :allow-empty="false",
                                        placeholder="",
                                        :multiple="false",
                                        :show-labels="false",
                                        :searchable="false",
                                    )
                                    help-text.add-sub-form__help-text(
                                        v-if='showDisplaySpeedIncreasingHelpText',
                                        slot='help-text',
                                        v-text="$i18n.t('trainer.trainer_gameFormHelpText_voiceOverWillDisableAfter') + showDisplaySpeedIncreasingHelpText + ' ' + $i18n.tc('trainer.trainer_gamePreview_exampleDeclination', showDisplaySpeedIncreasingHelpText)"
                                    )
                        .row
                            .form-container__column.form-container__column_fixed
                                label.form-container__label.form-container__label_fixed
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_minimalSpeed') }}
                                .form-container__select.form-container__select_spaced
                                    cs-checkbox#isMinimalSpeed(v-model='params.isMinimalSpeed', :checked="params && params.isMinimalSpeed")
                template(v-if="gameMode !== 'course'")
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_exampleComplication') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox(
                                    v-model='params.isComplication',
                                    :checked="params && params.isComplication",
                                    :disabled="isComplicationDisabled"
                                )
                    template(v-if='params.isComplication')
                        .row
                            .form-container__column
                                label.form-container__label
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_examplesToComplicate') }}
                                .form-container__select
                                    cs-multiselect(
                                        v-model='params.tasksForComplication',
                                        :options="availableTasksForComplication",
                                        :multiple="false",
                                        :show-labels="false",
                                        :allow-empty="false",
                                        placeholder="",
                                        :searchable="false",
                                    )
                        .row
                            .form-container__column
                                label.form-container__label
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_complicationOfActions') }}
                                .form-container__select
                                    cs-multiselect(
                                        v-model='params.complication',
                                        :options="complicationOptions",
                                        :searchable="false",
                                        :multiple="false",
                                        :show-labels="false",
                                        :allow-empty="false",
                                    )
                .row(v-if="gameMode === 'free-game'")
                    .form-container__column.form-container__column_fixed
                        label.form-container__label.form-container__label_fixed
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_dictation') }}
                        .form-container__select
                            cs-checkbox#dictation(v-model='params.dictation', :checked="params && params.dictation", :disabled="isMultiplayer")
                .row(v-if='params.dictation')
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
                        .form-container__select
                            cs-multiselect(
                                v-model='selectedTimeForAnswer',
                                :options="dictationSeconds",
                                @select="timeForAnswerHandler",
                                track-by="time",
                                label="label",
                                :multiple="false",
                                :allow-empty="false",
                                :show-labels="false",
                                :searchable="false",
                            )
                template(v-if="gameMode !== 'course'")
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#fractions(
                                    :checked='params && params.fractions',
                                    @change='fractionsHandler',
                                    :disabled="(params.roundNumbers || params.mirror)"
                                )
                    .row(v-if='params.fractions')
                        .form-container__column
                            label.form-container__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                            .form-container__select
                                cs-multiselect(
                                    v-model='params.fractionalPart',
                                    :options="fractionalPart",
                                    :multiple="false",
                                    :searchable="false",
                                    :allow-empty="false",
                                    :show-labels="false",
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_mirror') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#mirror(
                                    v-model='params.mirror',
                                    :checked="params && params.mirror",
                                    :disabled="(params.difficult === 'Однозначные цифры' || params.fractions || params.roundNumbers)"
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_roundNumbers') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#round-numbers(
                                    :checked='params && params.roundNumbers',
                                    @change='roundNumbersHandler'
                                    :disabled="roundNumbersDisabled"
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_positiveAnswers') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#positiveAnswers(
                                    v-model='params.positiveAnswers',
                                    :checked="params && params.positiveAnswers",
                                    :disabled="positiveAnswersDisabled"
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_negativeAnswers') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#negativeAnswers(
                                    v-model='params.negativeAnswers',
                                    :checked='params && params.negativeAnswers',
                                    :disabled="negativeAnswersDisabled"
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_interimAnswers') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#interimAnswers(
                                    v-model='params.interimAnswers',
                                    :checked='params && params.interimAnswers',
                                    :disabled="interimAnswersDisabled"
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_jumpOver50') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#jumpOver50(
                                    :checked='params && params.jumpOver50',
                                    v-model='params.jumpOver50',
                                    :disabled="!isAllowJumpOver"
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_jumpOver100') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#jumpOver100(
                                    :checked='params && params.jumpOver100',
                                    v-model='params.jumpOver100',
                                    :disabled="!isAllowJumpOver"
                                )
                    .row(v-if="params.withTime")
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_showAnswer') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox(
                                    v-model="params.showAnswer",
                                    :checked="params.showAnswer"
                                )
                .settings(v-if="!params.withTime")
                    divider
                    .settings-header
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_addParams') }}
                    .row
                        .form-container__settings
                            cs-checkbox(
                                v-model="params.showExampleInTheLine",
                                :checked="params.showExampleInTheLine"
                            )
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_exampleInTheLine') }}
                .settings
                    template(v-if='params.withTime')
                        .settings-header
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_addParams') }}
                        .row
                            .form-container__settings
                                cs-checkbox#pictures(
                                    v-model='params.extraOptions.pictures',
                                    :checked="params && params.extraOptions.pictures",
                                    :disabled="!isPicturesAvailable"
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_distractingPictures') }}
                            .form-container__settings
                                cs-checkbox#music(
                                    v-model='params.extraOptions.music',
                                    :checked="params && params.extraOptions.music",
                                    :disabled="!isMusicAvailable"
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_music') }}
                            .form-container__settings
                                cs-checkbox#x2(
                                    v-model='params.extraOptions.x2',
                                    :checked="params && params.extraOptions.x2",
                                    :disabled="!isX2Available"
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_x2') }}
                            .form-container__settings
                                cs-checkbox#motion(
                                    v-model='params.extraOptions.motion',
                                    :checked="params && params.extraOptions.motion",
                                    :disabled="!isMotionAvailable"
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_movement', {element: $i18n.t('trainer.trainer_gameFormSettingValue_numbers')}) }}
                            .form-container__settings
                                cs-checkbox#voice-over(
                                    v-model='params.extraOptions.voiceOver',
                                    :checked="params && params.extraOptions.voiceOver",
                                    :disabled="!isVoiceOverAvailable"
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_voiceActing') }}
                slot(name='parameters')
                .help-text
                    slot(name='help')
                template(v-if='!usersIds')
                    .form-container__footer-buttons
                        cs-button.cancel-button(type='button', @click='cancel', pattern="primary-outline", color="blue")
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                        template(v-if="gameMode && gameMode === 'free-game'")
                            cs-button.save-button(type='button', @click='saveGameMode', color="blue")
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                        template(v-else)
                            cs-button.save-button(type='button', @click='saveGame', color="blue")
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else)
                    .form-container__footer-buttons
                        cs-button.cancel-button(type='button', @click='cancel', pattern="primary-outline", color="blue")
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                        cs-button.save-button(type='button', color="blue", @click='saveGame')
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import { cloneDeep, find } from 'lodash';
    import { mapState } from 'vuex';
    import TrainerGames from '../../../config/trainer';
    import AddSubConfig from '../../trainer/configs/AddSubConfig';
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    const DEFAULT_TIME_LIMIT = 0;
    const DEFAULT_SPEED_ANZAN_WITH_TIME = 1;
    const DEFAULT_SPEED_ANZAN = 0;
    const DISABLED_VOICE_DIFFICULTIES = [4, 5, 6, 7, 8];
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import disableDictationForMultiplayer from '../../../utils/multiplayer/disableDictationForMultiplayer';
    import combiningCapacitiesMixin from '../utils/combiningCapacitiesMixin';
    import speedHelpTextMixin from '../utils/speedHelpTextMixin';

    import CombiningDigitCapacity from '../shared/CombiningDigitCapacity.vue';

    export default {
        components: {
            CombiningDigitCapacity,
        },
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        data() {
            return {
                gameTypes: [
                    {
                        name: this.$i18n.t('common.common_gameName_anzanWithoutTime'),
                        withTime: false,
                    },
                    {
                        name: this.$i18n.t('common.common_gameName_anzanWithTime'),
                        withTime: true,
                    },
                ],
                modes: [
                    {
                        value: 'abacus',
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbacus'),
                    },
                    {
                        value: 'mind',
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_inMind'),
                    },
                    {
                        value: 'any',
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_any'),
                    },
                ],
                difficult: [
                    {
                        value: 1,
                        $isDisabled: false,
                        name: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                    },
                    {
                        value: 2,
                        $isDisabled: false,
                        name: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                    },
                    {
                        value: 3,
                        $isDisabled: false,
                        name: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                    },
                    {
                        value: 4,
                        $isDisabled: false,
                        name: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                    },
                    {
                        value: 5,
                        $isDisabled: false,
                        name: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                    },
                    {
                        value: 6,
                        $isDisabled: false,
                        name: this.$i18n.t('common.common_gameSetting_sixDigitsNum'),
                    },
                    {
                        value: 7,
                        $isDisabled: false,
                        name: this.$i18n.t('common.common_gameSetting_sevenDigitsNum'),
                    },
                    {
                        value: 8,
                        $isDisabled: false,
                        name: this.$i18n.t('common.common_gameSetting_eightDigitsNum'),
                    },
                ],
                seconds: AddSubConfig.seconds,
                timeLimitValues: AddSubConfig.timeLimitValues,
                params: null,
                selectedDifficult: null,
                selectedMode: null,
                selectedGameType: null,
                examples: 100,
                selectedTimeLimit: null,
                selectedAnswerDuration: null,
                secondsInMinute: [...Array(61).keys()].slice(1).map(time => {
                    return {
                        time: time,
                        label: `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds'),
                    };
                }),
                selectedSpeed: null,
                selectedSpeedUp: null,
                selectedTimeForAnswer: null,
                dictationSeconds: [...Array(101).keys()].slice(1).map(time => {
                    return {
                        time: time,
                        label: `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds'),
                    };
                }),
                fractionalPart: [...Array(3).keys()].slice(1),
            };
        },
        mixins: [
            GameFormMixin,
            multiplayerFormMixin,
            speedHelpTextMixin,
            combiningCapacitiesMixin,
            disableDictationForMultiplayer,
        ],
        mounted() {
            if (this.isGeneratorSettings) {
                if (this.homework && this.homework.grades && this.homework.grades.length) {
                    let currentGameSettings = this.homework.grades[0].course.games.find(
                        element => element.slug == this.slug
                    );
                    this.gamesParameters[this.slug] = currentGameSettings.parameters.default;
                }
                if (this.homework && this.homework.courses) {
                    let copyCourses = this.homework.courses.filter(course =>
                        course.games.find(element => element.slug == this.slug)
                    );
                    copyCourses.sort((a, b) => a.level - b.level);
                    let currentGameSettings = copyCourses[0].games.find(element => element.slug == this.slug);
                    this.gamesParameters[this.slug] = currentGameSettings.parameters.default;
                }
            }

            if (this.gameMode === 'free-game') {
                if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                    let difficultIndex = this.difficult
                        .map(difficulty => difficulty.value)
                        .indexOf(this.gamesParameters[this.slug].difficult);
                    for (let i = difficultIndex + 1; i < this.difficult.length; i++) {
                        this.difficult[i].$isDisabled = true;
                    }
                }
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else {
                    cloneDeep(TrainerGames.games).forEach(item => {
                        if (item.slug === this.slug) {
                            this.params = item.parameters.default;
                        }
                    });
                }
                this.params.infinityAmountOfExamples = true;
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedDifficult = find(this.difficult, { value: this.params.difficult });
            this.selectedMode = find(this.modes, { value: this.params.mode });
            this.selectedGameType = find(this.gameTypes, { withTime: this.params.withTime });
            this.selectedTimeLimit = this.formattedTimeLimitValues.find(
                value => value.amount === this.params.timeLimit
            );
            this.selectedAnswerDuration = this.secondsInMinute.find(value => value.time === this.params.answerDuration);
            this.selectedSpeed = this.formattedSeconds.find(value => value.time === this.params.speed);
            this.selectedSpeedUp = this.secondsForSpeedUp.find(value => value.time === this.params.speedUp);
            this.selectedTimeForAnswer = this.dictationSeconds.find(value => value.time === this.params.timeForAnswer);
            console.log(this.selectedGameType);
        },
        updated() {
            this.selectedDifficult = find(this.difficult, { value: this.params.difficult });
            this.selectedMode = find(this.modes, { value: this.params.mode });
            this.selectedGameType = find(this.gameTypes, { withTime: this.params.withTime });
            this.selectedTimeLimit = this.formattedTimeLimitValues.find(
                value => value.amount === this.params.timeLimit
            );
            this.selectedAnswerDuration = this.secondsInMinute.find(value => value.time === this.params.answerDuration);
            this.selectedSpeed = this.formattedSeconds.find(value => value.time === this.params.speed);
            this.selectedSpeedUp = this.secondsForSpeedUp.find(value => value.time === this.params.speedUp);
            this.selectedTimeForAnswer = this.dictationSeconds.find(value => value.time === this.params.timeForAnswer);
            console.log(this.selectedGameType);
        },
        watch: {
            'params.withTime': {
                handler(val) {
                    if (this.playersNumber && this.playersNumber > 1) {
                        this.paramsArray = this.paramsArray.map(params => {
                            params.withTime = val;
                            return params;
                        });
                    }
                },
            },
            'params.extraOptions.x2': {
                handler(val) {
                    this.gameMode !== 'course' && val && (this.params.extraOptions.motion = false);
                },
            },
            'params.extraOptions.motion': {
                handler(val) {
                    this.gameMode !== 'course' && val && (this.params.extraOptions.x2 = false);
                },
            },
            combiningDisabled(val) {
                if (val) {
                    this.params.combining = false;
                }
            },
            'params.speed'() {
                if (
                    this.params.speedUp >= this.params.speed &&
                    this.secondsForSpeedUp[this.secondsForSpeedUp.length - 1]
                ) {
                    this.params.speedUp = this.secondsForSpeedUp[this.secondsForSpeedUp.length - 1].time;
                }
            },
            'params.amountOfExamples'(val) {
                if (this.params.tasksForSpeedUp >= this.params.amountOfExamples && this.params.amountOfExamples !== 1) {
                    this.params.tasksForSpeedUp = this.params.amountOfExamples - 1;
                }
                if (this.params.timeLimit) {
                    this.params.tasksForComplication = 1;
                } else if (this.params.tasksForComplication >= val && val !== 1) {
                    this.params.tasksForComplication = val - 1;
                }
                if (val) {
                    this.$set(this.params, 'timeLimit', DEFAULT_TIME_LIMIT);
                }
            },
            'params.amountOfActions'(val) {
                let maxActions = 15;
                if (this.params.withTime) {
                    maxActions = 100;
                }
                if (this.params.complication + val > maxActions) {
                    this.params.complication = maxActions - val;
                }
                if (this.params.amountOfActions === maxActions) {
                    this.params.complication = 1;
                }
            },
            'params.timeLimit'(val) {
                if (val) {
                    this.params.amountOfExamples = false;
                } else {
                    if (!this.params.amountOfExamples) {
                        this.params.amountOfExamples = 1;
                    }
                }
            },
            'params.dictation'(val) {
                if (val) {
                    this.params.extraOptions && (this.params.extraOptions.x2 = false);
                    this.params.timeLimit = 0;
                    this.params.infinityAmountOfExamples = false;
                }
            },
            isVoiceOverAvailable(val) {
                !val && (this.params.extraOptions.voiceOver = val);
            },
            isAllowJumpOver(val) {
                if (!val) {
                    this.params.jumpOver50 = false;
                    this.params.jumpOver100 = false;
                }
            },
            isSpeedIncreaseDisabled(val) {
                val && (this.params.isSpeedIncrease = false);
            },
            isComplicationDisabled(val) {
                val && (this.params.isComplication = false);
            },
            'params.jumpOver50'(val) {
                if (val) {
                    this.params.interimAnswers = false;
                }
            },
            'params.jumpOver100'(val) {
                if (val) {
                    this.params.interimAnswers = false;
                }
            },
        },
        methods: {
            difficultHandler(difficult) {
                this.params.difficult = difficult.value;
                if (this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
                if (this.combiningDisabled) {
                    this.params.combiningDigitCapacities = [];
                }
            },
            combiningHandler() {
                this.params.combining = !this.params.combining;
                if (this.params.combining) {
                    this.params.mirror = false;
                }
                this.params.combiningDigitCapacities = [];
                if (this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            roundNumbersHandler(event) {
                this.params.roundNumbers = !this.params.roundNumbers;
                if (this.params.roundNumbers && this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            fractionsHandler() {
                this.params.fractions = !this.params.fractions;
                if (this.params.fractions) {
                    this.params.mirror = false;
                    this.params.roundNumbers = false;
                }
                if (this.params.fractions && this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            decreaseActions() {
                if (this.params.amountOfActions !== 2) {
                    this.params.amountOfActions -= 1;
                }
            },
            increaseActions() {
                if (this.params.amountOfActions !== this.actions) {
                    this.params.amountOfActions += 1;
                }
            },
            decreaseExamples() {
                if (
                    this.params.amountOfExamples !== 1 &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples -= 1;
                }
            },
            increaseExamples() {
                if (
                    this.params.amountOfExamples !== this.examples &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples += 1;
                }
            },
            timeLimitHandler(value) {
                this.params.timeLimit = value.amount;
            },
            answerDurationHandler(value) {
                this.params.answerDuration = value.time;
            },
            displaySpeedHandler(value) {
                this.params.withSpeed = !!value.time;
                this.params.speed = value.time;
            },
            speedUpHandler(value) {
                this.params.speedUp = value.time;
            },
            timeForAnswerHandler(value) {
                this.params.timeForAnswer = value.time;
            },
            gameTypeHandler(value) {
                console.log(value);
                this.params.withTime = value.withTime;
                if (value.withTime) {
                    this.params.speed = DEFAULT_SPEED_ANZAN_WITH_TIME;
                    this.selectedSpeed = this.formattedSeconds.find(
                        value => value.time === DEFAULT_SPEED_ANZAN_WITH_TIME
                    );
                } else {
                    this.params.speed = DEFAULT_SPEED_ANZAN;
                    this.selectedSpeed = this.formattedSeconds.find(value => value.time === DEFAULT_SPEED_ANZAN);
                }
            },
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            isGeneratorSettings() {
                if (this.gameMode == 'generator-settings' && this.gamesParameters) {
                    return true;
                }
                return false;
            },
            combiningDigitCapacities() {
                return this.params && this.params.combiningDigitCapacities;
            },
            isAllowJumpOver() {
                return (
                    this.params &&
                    !this.params.combining &&
                    !this.params.mirror &&
                    !this.params.roundNumbers &&
                    !this.params.fractions &&
                    (this.params.difficult === 2 || this.params.difficult === 3)
                );
            },
            fractionsDisabled() {
                return (
                    this.params.roundNumbers || this.params.mirror || this.params.jumpOver100 || this.params.jumpOver50
                );
            },
            roundNumbersDisabled() {
                return (
                    this.params.difficult === 1 ||
                    this.params.fractions ||
                    this.params.mirror ||
                    this.params.jumpOver100 ||
                    this.params.jumpOver50
                );
            },
            mirrorDisabled() {
                return (
                    this.params.difficult === 1 ||
                    this.params.fractions ||
                    this.params.roundNumbers ||
                    this.params.jumpOver100 ||
                    this.params.jumpOver50 ||
                    this.params.combining
                );
            },
            positiveAnswersDisabled() {
                return this.params.positiveAnswers && !this.params.negativeAnswers;
            },
            negativeAnswersDisabled() {
                return this.params.negativeAnswers && !this.params.positiveAnswers;
            },
            secondsForSpeedUp() {
                return this.seconds.slice(0, this.seconds.indexOf(this.params.speed)).map(time => {
                    return {
                        time: time,
                        label: `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds'),
                    };
                });
            },
            isPicturesAvailable() {
                return !this.gamesParameters || this.gamesParameters[this.slug].extraOptions.pictures;
            },
            isX2Available() {
                return (
                    (!this.gamesParameters || this.gamesParameters[this.slug].extraOptions.x2) &&
                    (!this.playersNumber || this.playersNumber === 1) &&
                    !this.params.dictation
                );
            },
            isMotionAvailable() {
                return (
                    (!this.gamesParameters || this.gamesParameters[this.slug].extraOptions.motion) &&
                    (!this.playersNumber || this.playersNumber === 1)
                );
            },
            isMusicAvailable() {
                return (
                    (!this.gamesParameters || this.gamesParameters[this.slug].extraOptions.music) &&
                    (!this.playersNumber || this.playersNumber === 1)
                );
            },
            isVoiceOverAvailable() {
                return (
                    this.gameMode === 'course' ||
                    (this.params &&
                        this.params.withTime &&
                        !DISABLED_VOICE_DIFFICULTIES.includes(this.params.difficult) &&
                        !this.params.fractions &&
                        (!this.gamesParameters || this.gamesParameters[this.slug].extraOptions.voiceOver) &&
                        (!this.playersNumber || this.playersNumber === 1))
                );
            },
            actions() {
                return this.params && this.params.withTime ? 99 : 14;
            },
            isSpeedIncreaseDisabled() {
                return (
                    (this.gamesParameters && this.gamesParameters[this.slug]?.isSpeedIncrease) ||
                    (this.params && this.params.amountOfExamples <= 1) ||
                    (this.params && this.params.speed <= 0.1)
                );
            },
            isComplicationDisabled() {
                return (
                    (this.gamesParameters && this.gamesParameters[this.slug]?.isComplication) ||
                    (this.params && this.params.amountOfExamples <= 1 && !this.params.timeLimit) ||
                    (this.params && this.params.amountOfActions >= 100 && this.params.withTime) ||
                    (this.params && this.params.amountOfActions >= 15 && !this.params.withTime)
                );
            },
            showAnswerDurationHelpText() {
                return !this.params.answerDuration;
            },
            combiningDisabled() {
                return (
                    this.params &&
                    (this.params.difficult === 1 ||
                        this.params.mirror ||
                        (this.params.difficult === 2 && this.params.roundNumbers) ||
                        this.params.jumpOver100 ||
                        this.params.jumpOver50)
                );
            },
            isTimeLimitAvailable() {
                return (
                    !['course', 'generator-settings'].includes(this.gameMode) && this.params && !this.params.withTime
                );
            },
            formattedTimeLimitValues() {
                return this.timeLimitValues.map(amount => {
                    return {
                        amount: amount,
                        label: amount
                            ? `${amount} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes')
                            : this.$i18n.t('trainer.trainer_gameFormSettingValue_off'),
                    };
                });
            },
            formattedSeconds() {
                if (!this.params.withTime) {
                    return this.seconds.map(time => {
                        return {
                            time: time,
                            label: time
                                ? `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds')
                                : this.$i18n.t('trainer.trainer_gameFormSettingValue_off'),
                        };
                    });
                }
                return this.seconds
                    .filter(value => value !== 0)
                    .map(time => {
                        return {
                            time: time,
                            label: `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds'),
                        };
                    });
            },
            availableTasksForComplication() {
                const complicationLastNumber = this.params.timeLimit ? this.examples : this.params.amountOfExamples - 1;
                return [...Array(complicationLastNumber).keys()].slice(1);
            },
            tasksForSpeedUpOptions() {
                return [...Array(this.params.amountOfExamples).keys()].slice(1);
            },
            complicationOptions() {
                let sequenceLastNumber = (this.params && this.params.withTime ? 101 : 16) - this.params.amountOfActions;
                return [...Array(sequenceLastNumber).keys()].slice(1);
            },
            interimAnswersDisabled() {
                return this.params.jumpOver100 || this.params.jumpOver50;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .title {
        margin-bottom: 25px;
        display: flex;
        justify-content: center;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
    }
    .row {
        margin: 0;
    }
    .form-container {
        width: 100%;
        max-width: 1020px;
        margin: 0 auto;
    }
    .form-container__column {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
    }
    .form-container__column_fixed {
        @media screen and (max-width: 767px) {
            flex-direction: row;
        }
        @media screen and (max-width: 575px) {
            flex-direction: row;
        }
    }
    .form-container__label {
        margin-right: 20px;
        width: 30%;
        text-align: right;
        @media screen and (max-width: 767px) {
            width: 100%;
            margin: 0 0 10px 0;
            text-align: left;
        }
    }
    .form-container__label_fixed {
        @media screen and (max-width: 767px) {
            margin-right: 20px;
            width: 100%;
            text-align: right;
        }
        @media screen and (max-width: 575px) {
            text-align: left;
            margin-right: 0;
        }
    }
    .input-label {
        @media screen and (max-width: 767px) {
            text-align: left;
        }
    }
    .form-container__select {
        width: 100%;
        max-width: 300px;
        @media screen and (max-width: 767px) {
            max-width: none;
        }
    }
    .form-container__select_spaced {
        @media screen and (max-width: 575px) {
            width: auto;
        }
    }
    .form-container__select_short {
        display: flex;
        align-items: center;
    }
    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }

    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }

    .form-container__checkbox {
        margin-left: 30px;
    }

    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }
    .form-container__settings {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 40px;
    }
    .setting__checkbox {
        margin-right: 30px;
        @media screen and (max-width: 991px) {
            margin-bottom: 30px !important;
        }
        @media screen and (max-width: 575px) {
            margin-bottom: 40px !important;
        }
        @media screen and (max-width: 359px) {
            margin-right: 20px;
        }
    }
    .settings-header {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        margin-bottom: 20px;
    }
    .form-container__footer-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
    }
    .cancel-button {
        width: 200px;
    }
    .save-button {
        width: 200px;
        margin-left: 20px;
        @media screen and (max-width: 767px) {
            margin: 20px 0 0 0;
        }
    }
    .help-text {
        color: #888888;
    }
    .combining-label {
        @media screen and (max-width: 359px) {
            display: none;
        }
    }
</style>
